export function calculateScaledImageSize(
  imageWidth: number,
  imageHeight: number,
  containerWidth: number,
  containerHeight: number
) {
  const imageAspectRatio = imageWidth / imageHeight;
  const containerAspectRatio = containerWidth / containerHeight;

  let scaledWidth, scaledHeight;

  if (imageAspectRatio > containerAspectRatio) {
    // 画像が横長の場合、幅をコンテナに合わせる
    scaledWidth = containerWidth;
    scaledHeight = containerWidth / imageAspectRatio;
  } else {
    // 画像が縦長または正方形の場合、高さをコンテナに合わせる
    scaledHeight = containerHeight;
    scaledWidth = containerHeight * imageAspectRatio;
  }

  // 小数点以下を正確に保持して返す
  return { width: scaledWidth, height: scaledHeight };
}
